export const BOOTSTRAP_FUNDERS = 'BOOTSTRAP_FUNDERS'
export const SET_SELECTED_FUNDERS = 'SET_SELECTED_FUNDERS'
export const SET_TOTAL_FUNDERS = 'SET_TOTAL_FUNDERS'
export const RESET_SELECTED_FUNDER = 'RESET_SELECTED_FUNDER'
export const VIEW_FUNDER = 'VIEW_FUNDER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'